export const transferEn = {
  'transfer-heading': 'Transfers',
  'transfer-make-transfer-title': 'Between Accounts',
  'transfer-to-my-account-text': 'To My Bank Account',
  'transfer-balance-label': 'Available Balance:',
  'transfer-send-money-title': 'Send Money',
  'transfer-account-to-account-text': 'Card to Card',
  'transfer-person-to-person-text': 'Person to Person',
  'transfer-not-enabled-alert':
    'Transfers have not been enabled for your accounts\' program at this time.',
  'transfer-person-to-external-title': 'Request Money',
  'transfer-request-money-title': 'Request Money',
  'transfer-person-to-external-text': 'From External Contact',
  'transfer-etransfer-push-text': 'INTERAC e-Transfer{registerSuperscript} {registerFooterNote}',
  'transfer-etransfer-pull-text': 'INTERAC e-Transfer{registerSuperscript} {registerFooterNote}',
  'transfer-directsend-push-text': 'Push to an account using Debit Card',
  'transfer-directsend-pull-text': 'Pull from an account using Debit Card',
  'transfer-etransfer-footnote-text': '{registerFooterNote} INTERAC e-Transfer{registerSuperscript} is a registered trademark of Interac Inc. Used under license.',
  'transfer-etransfer-issue-banner-alert':
  'Interac e-Transfer® is unavailable. Please use Visa Direct or withdraw from an ATM.',
};

export const transferFr = {
  'transfer-heading': 'Transferts',
  'transfer-make-transfer-title': 'Entre les comptes',
  'transfer-to-my-account-text': 'Vers mon compte bancaire',
  'transfer-balance-label': 'Solde disponible:',
  'transfer-send-money-title': 'Envoyer de l\'argent',
  'transfer-account-to-account-text': 'Carte à carte',
  'transfer-person-to-person-text': 'Personne à personne',
  'transfer-not-enabled-alert':
    'Les transferts n\'ont pas été activés pour le programme de vos comptes pour le moment.',
  'transfer-person-to-external-title': 'Demander de l\'argent',
  'transfer-request-money-title': 'Demander de l\'argent',
  'transfer-person-to-external-text': 'Personne externe',
  'transfer-etransfer-push-text': 'INTERAC virement électronique{registerSuperscript}  {registerFooterNote}',
  'transfer-etransfer-pull-text': 'INTERAC virement électronique{registerSuperscript}  {registerFooterNote}',
  'transfer-directsend-push-text': 'Envoyer vers un compte en utilisant une carte de débit',
  'transfer-directsend-pull-text': 'Tirer depuis un compte en utilisant une carte de débit',
  'transfer-etransfer-footnote-text': '{registerFooterNote} INTERAC virement électronique{registerSuperscript} est une marque déposée d\'Interac Inc. Utilisée sous licence.',
  'transfer-etransfer-issue-banner-alert':
  // eslint-disable-next-line quotes
  `Le Virement Interac® n'est pas disponible. Veuillez utiliser Visa Direct ou retirer de l'argent à un guichet automatique.`,
};
